<template>
  <div v-if="!isInternationalMode">
    <h2 class="h3 title small-margin-bottom-s large-margin-bottom-m" :class="{ h4: isMobile }">Ratings & Reviews</h2>

    <span class="no-reviews-text">{{ noReviewsText }}</span>

    <div class="margin-top-s">
      <Reviewlet :interactive="true" size="large" @onchange="redirectToWriteReview" />
    </div>
  </div>
</template>

<script setup lang="ts">
import Reviewlet from '@atomic-ui/reviewlet/Reviewlet';
import { useBrand } from '~/composables/useBrand';
import { useDeviceType } from '~/composables/utils/useDeviceType';
import useReviewsRedirect from '~/modules/reviews/composables/useReviewsRedirect';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';

const { isMcom } = useBrand();
const { isMobile } = useDeviceType();

const { redirectToWriteReview } = useReviewsRedirect();

const { isInternationalMode } = useFeatureEligibility();

const noReviewsText = isMcom ? 'No reviews yet. Tell us what you think!' : 'Hey trailblazer! Be the first to write a review.';
</script>

<style lang="scss" scoped>
@import '~settingSCSS';
.no-reviews-text {
  font-weight: 500;
}
// this was changed from h3 tag h2
// override is added to comply with previous spacing, that is overriden on Product.vue level
// when decided to remmove override for h3 spacing  on Product.vue - this can be deleted too
// There is TODO for that TD#1
.title {
  @include breakpoint(large up) {
    margin-bottom: rem-calc(24) !important;
  }
}
</style>
